export default {
    auto: 'Automatic',
    manual: 'Manual',
    sequential: 'Sequential',
};
